import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx7jj6d3f8: FaireProductEntity = {
  token: "p_tx7jj6d3f8",
  type: "product",
  name: "66 Colorful Ricrac-Trimmed Canvas Everyday Tote Bag",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fe69603cfcab3fd30245df08a90633679c9d10439cdb4043991606002a732705.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21049a2d102c5b83541bed0e69218507e5ea75360dc7c6f0640db4f29569f441.jpeg",
    "https://cdn.faire.com/fastly/b4f94cf2b7c4f519c1217af8e7ad0de3027844be4c37ac81c7cde063457cc513.jpeg",
    "https://cdn.faire.com/fastly/3b9453c3ddd0fd0198394c194ec0e258c8b8d50562103988e7d7448e9d5e51b5.jpeg",
    "https://cdn.faire.com/fastly/549b17499bef2c92eb085ead10528c221e3f774b888bbda50818b4b9782b674c.jpeg",
    "https://cdn.faire.com/fastly/ee0ee89a2af047bf195ffbe5b7775c8beb5c5415295b13dbee3ab137744d1b61.jpeg",
    "https://cdn.faire.com/fastly/6c1b415099bd60c53ced144d751dca74125fa3ce950f92caff9e042431491e6b.jpeg",
    "https://cdn.faire.com/fastly/94ca2a677d31363e23d48597d08b68b0f9afbe126be04096d537a11fd50c3570.jpeg",
    "https://cdn.faire.com/fastly/18b34672b9b4b625393748e81bd95c739731d8e3bbc954eb15ab149f7ceb8d85.jpeg",
  ],
  priceDollars: 19.54,
  description:
    "🎀Material: Canvas\n😍Why You’ll Love It?\n\nVibrant colorful ricrac detail adds a playful, festive, and eye-catching trim.\nDurable canvas construction ensures a sturdy bag perfect for daily use and travel.\nSpacious tote design offers ample capacity for shopping, beach days, or errands.\nA fun, functional bag that easily elevates any casual or vacation look.\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!",
  tags: [],
  msrpDollars: 39.08,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:36.730Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
